export function stackItemsTranslate() {
  const stackLists = document.querySelectorAll(".stack-icons-list");

  if (stackLists) {
    stackLists.forEach((list) => {
      const items = list.querySelectorAll("li");

      if (list.classList.contains("stack-icons-list-right")) {
        let newItemsArr = [...items];
        newItemsArr.reverse();
        newItemsArr.forEach((item, index) => {
          if (index > 0) {
            item.style.transform = `translateX(${8 * index}px)`;
          }
        });
      } else {
        items.forEach((item, index) => {
          if (index > 0) {
            item.style.transform = `translateX(${-8 * index}px)`;
          }
        });
      }
    });
  }
}
